module.exports = __webpack_public_path__ + "assets/images/electoral-college/map/bg-mobile.jpg?v=3f13ce8b";